import { render, staticRenderFns } from "./MrsNewsSyllables.vue?vue&type=template&id=6a230add&scoped=true&"
import script from "./MrsNewsSyllables.vue?vue&type=script&lang=js&"
export * from "./MrsNewsSyllables.vue?vue&type=script&lang=js&"
import style0 from "./MrsNewsSyllables.vue?vue&type=style&index=0&id=6a230add&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a230add",
  null
  
)

export default component.exports